import { forwardRef } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components/macro";
import { lightText, brightBlue } from "../../../constants/colors";
import {
  FONT_SIZE_LARGE,
  BREAKPOINT_MUI_NAV_SHRINK_8_PX,
  FONT_SIZE_MEDIUM,
  LOGO_HEIGHT,
} from "../../../constants/constants";
import RavenLogoSVG from "./RavenLogoSVG";
import { useFlightConfig } from "components/DataGetter/FlightConfig/useFlightConfig";
import { useLocalStorage } from "react-use";

const RavenLogoStyles = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${LOGO_HEIGHT}px;
  width: 100%;
  margin: auto;
  letter-spacing: 5px;
  pointer-events: none;
  font-size: ${FONT_SIZE_MEDIUM}px;
  .ravenLogoBase {
    color: ${lightText};
    font-family: "GothamBook";
    font-weight: 100;
  }
  .ravenA {
    color: ${brightBlue};
  }
  .link {
    pointer-events: auto;
  }
  @media (min-width: ${BREAKPOINT_MUI_NAV_SHRINK_8_PX}px) {
    font-size: ${FONT_SIZE_LARGE}px;
    height: ${LOGO_HEIGHT + 8}px;
  }
  @media print {
    font-size: ${FONT_SIZE_MEDIUM}px;
    height: ${LOGO_HEIGHT}px;
  }
`;

export default forwardRef((props, ref) => {
  return (
    <RavenLogoStyles>
      <div className="linkContainer" ref={ref as any}>
        <Link className="link" to={"/"} style={{ textDecoration: "none" }}>
          <RavenLogoSvgOrWhitelabelLogo />
        </Link>
      </div>
    </RavenLogoStyles>
  );
});

export function RavenLogoSvgOrWhitelabelLogo() {
  const [
    {
      general: { whitelabel },
    },
  ] = useFlightConfig();
  const storedWhitelabelConfig = useLocalStorage(
    "whitelabelConfig",
    whitelabel
  );
  const { logoUrl, logoHeight, logoWidth } =
    whitelabel ?? storedWhitelabelConfig;
  return logoUrl ? (
    <img
      src={logoUrl}
      style={{ height: logoHeight ?? 32, width: logoWidth ?? "auto" }}
    />
  ) : (
    <RavenLogoSVG />
  );
}
